import { HNG_APP_CONFIG, HngAppConfig } from '@hidat/ng-common';
import { environment } from '../environments/environment';
import {
  EventTrackerConfig,
  EventTrackerModule,
  loadStationInitializer,
} from '@splixer/player';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';
import { appRoutes } from './app.routes';
import { PlayerAutoPlayModes } from '@splixer/common';

const appConfig = new HngAppConfig({
  appCode: 'kmhd-player',
  appName: 'KMHD Archived Shows',
  apiUrl: environment.splixerUrl,
  userApiUrl: '',
});

const eventTrackerConfig: EventTrackerConfig = {
  primaryTrackingCode: environment.defaultGaTrackingId,
};

export const kmhdConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HNG_APP_CONFIG, useValue: appConfig },
    importProvidersFrom(
      NgxGoogleAnalyticsModule.forRoot(environment.defaultGaTrackingId),
    ),
    importProvidersFrom(NgxGoogleAnalyticsRouterModule),
    importProvidersFrom(EventTrackerModule.forRoot(eventTrackerConfig)),
    provideAppInitializer(() => {
      return loadStationInitializer(environment.defaultStationCode, 'KMHD', {
        featured: true,
        recents: false,
        genres: false,
        mixCategories: false,
        autoPlayMode: PlayerAutoPlayModes.NEXT_BROADCAST,
        dmcaSkipSeconds: 0,
      });
    }),
  ],
};
